import { baseApi } from "./base.api";

// NOTE: backend module must have a boolean `status` column on its model.
// Modules without `status` will 500 on toggle. Keep MODULE_TAGS in sync with
// backend MODULE_MAP in services/admin/toggle-status-service.js.
const MODULE_TAGS = {
  brand: "Brand",
  category: "Category",
  "sub-category": "SubCategory",
  product: "Product",
  blog: "Blog",
  "blog-category": "BlogCategory",
  banner: "Banner",
  "social-link": "SocialLink",
  "email-template": "WebsiteSetting",
  user: "User",
  role: "Role",
  review: "Review",
  district: "District",
  taluka: "Taluka",
  unit: "Unit",
  lab_test: "LabTest",
  lab_report:"LabReport",
  patient_referral: "ReferralPatient",
  patient_visit:"PatientVisit"
  
};

export const toggleStatusApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    toggleStatus: build.mutation({
      query: ({ module, id }) => ({
        url: `/toggle-status/${module}/${id}`,
        method: "PUT",
      }),
      invalidatesTags: (_result, _err, { module }) => {
        const tag = MODULE_TAGS[module];
        return tag ? [tag] : [];
      },
    }),
  }),
  overrideExisting: false,
});

export const { useToggleStatusMutation } = toggleStatusApi;
